import API from "../models/API";
import { RoleStore } from "../stores/impl/RoleStore";
import { LoginStatus } from "./LoginStatus";
import Role, { RoleData } from "./Role";

export default class Authenticator {
  constructor() {}

  setJwtAuth(jwt: string) {
    API.authToken = jwt;
  }

  async amLoggedIn(): Promise<LoginStatus | null> {
    return await API.loginStatus();
  }

  /**
   * This method will issue the authentication request to the Accelerator API
   * The API class itself automagically handles token storage
   */
  async login(username: string, password: string): Promise<boolean> {
    try {
      return await API.login({
        username: username,
        password: password,
      });
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async logout() {
    await API.logout().then((resp: Response | null) => {
      if (resp == null) {
        // throw error
      } else {
        window.location.href = resp.url;
      }
    });
  }

  async getCurrentRoles(): Promise<boolean> {
    try {
      const resp: Response = await API.get("/v0/roles/user/all");
      const roleDatas: RoleData[] = await resp.json();
      roleDatas.forEach((r) =>
        // store role without overwriting
        RoleStore.set(new Role(r), false),
      );
    } catch (e) {
      return false;
    }
    return true;
  }
}
